import { ProtectedRoute } from '@drycut/controlled-components';
import { PageLoading, StoreAdminLayout } from '@drycut/stylist-components';
import { Error404 } from '@drycut/ui-components';
import { Suspense } from 'react';
import { createBrowserRouter, Outlet } from 'react-router';

import { Dashboard, Login, Queue } from './routes';
import StorePubSubInit from './StorePubSubInit';

export default createBrowserRouter([
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    element: (
      <ProtectedRoute>
        <StorePubSubInit />
        <StoreAdminLayout>
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
        </StoreAdminLayout>
      </ProtectedRoute>
    ),
    children: [
      {
        path: '/dashboard',
        element: <Dashboard />,
      },
      {
        path: '/queue',
        element: <Queue />,
      },
    ],
  },
  {
    path: '/not-found',
    element: <Error404 />,
  },
  {
    path: '*',
    element: <Error404 />,
  },
]);
